import { Link } from "react-router-dom";

export default function LegalLayout({ eyebrow, title, updated, sections, testId = "legal-page" }) {
  return (
    <main className="pt-32 md:pt-40 pb-24 md:pb-32 bg-canvas" data-testid={testId}>
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <aside className="lg:col-span-3 lg:sticky lg:top-28">
            <div className="label-eyebrow">{eyebrow}</div>
            <div className="mt-3 font-mono text-xs text-ink/50">Updated {updated}</div>
            <nav className="mt-8 space-y-1.5 border-l border-forest/10 pl-4">
              {sections.map((s) => (
                <a
                  key={s.id}
                  href={`#${s.id}`}
                  className="block text-sm text-ink/60 hover:text-forest transition-colors"
                  data-testid={`legal-toc-${s.id}`}
                >
                  {s.title}
                </a>
              ))}
            </nav>
            <div className="mt-10 hairline" />
            <div className="mt-6 text-xs text-ink/50 space-y-2">
              <Link to="/legal/terms" className="link-reveal block">Terms of service</Link>
              <Link to="/legal/privacy" className="link-reveal block">Privacy policy</Link>
              <Link to="/legal/aml-kyc" className="link-reveal block">AML / KYC policy</Link>
              <Link to="/legal/cookies" className="link-reveal block">Cookie policy</Link>
            </div>
          </aside>

          <article className="lg:col-span-9 max-w-3xl">
            <h1 className="font-display font-medium text-forest text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tightest">
              {title}
            </h1>

            <div className="mt-12 space-y-14">
              {sections.map((s, i) => (
                <section key={s.id} id={s.id} data-testid={`legal-section-${s.id}`}>
                  <div className="flex items-baseline gap-4 mb-4">
                    <span className="font-mono text-xs tracking-[0.22em] text-ink/40">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h2 className="font-display font-medium text-forest text-2xl md:text-3xl tracking-tight">
                      {s.title}
                    </h2>
                  </div>
                  <div className="prose prose-neutral max-w-none text-ink/75 leading-relaxed space-y-4">
                    {s.body.map((p, j) => (
                      <p key={j} className="text-[15px] leading-[1.75]">{p}</p>
                    ))}
                  </div>
                </section>
              ))}
            </div>

            <div className="hairline mt-16" />
            <div className="mt-8 text-sm text-ink/50">
              Questions? Email{" "}
              <a href="mailto:legal@instantxfer.com" className="link-reveal text-forest">
                legal@instantxfer.com
              </a>
              .
            </div>
          </article>
        </div>
      </div>
    </main>
  );
}
